import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Toaster } from "#components/molecules/Toaster/Toaster";

import type { CSSProperties } from "react";

export const NOTIFICATIONS_STACK_STYLE: CSSProperties = {
  "--mantine-spacing-md": spacing[8],
} as CSSProperties;

export const AUTO_CLOSE_TOAST_DURATION = 8000;

const TOASTER_NOTIFICATION_STYLES = {
  root: {
    padding: 0,
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
  body: {
    margin: 0,
    flex: "1 0 auto",
    overflow: "visible",
  },
  description: {
    overflow: "visible",
    textOverflow: "clip",
  },
} as const;

export const showV2Toast = ({
  id,
  message,
  autoClose = AUTO_CLOSE_TOAST_DURATION,
  onCancel,
}: {
  id?: string;
  message: string;
  autoClose?: number | false;
  onCancel?: () => void;
}) => {
  notifications.show({
    id,
    autoClose,
    withCloseButton: false,
    color: colors.bg.elevation.primary,
    radius: radius.md,
    styles: TOASTER_NOTIFICATION_STYLES,
    message: <Toaster type="default" message={message} onCancel={onCancel} />,
  });
};

export const updateV2Toast = ({
  id,
  message,
  autoClose = AUTO_CLOSE_TOAST_DURATION,
  onCancel,
}: {
  id: string;
  message: string;
  autoClose?: number | false;
  onCancel?: () => void;
}) => {
  notifications.update({
    id,
    autoClose,
    withCloseButton: false,
    color: colors.bg.elevation.primary,
    radius: radius.md,
    styles: TOASTER_NOTIFICATION_STYLES,
    message: <Toaster type="default" message={message} onCancel={onCancel} />,
  });
};

export const showV2CompactToast = ({
  id,
  message,
  autoClose = AUTO_CLOSE_TOAST_DURATION,
}: {
  id?: string;
  message: string;
  autoClose?: number | false;
}) => {
  const notificationId = id ?? `toaster-${crypto.randomUUID()}`;

  notifications.show({
    id: notificationId,
    autoClose,
    withCloseButton: false,
    color: colors.bg.elevation.primary,
    radius: radius.md,
    styles: TOASTER_NOTIFICATION_STYLES,
    message: (
      <Toaster
        type="compact"
        message={message}
        onClose={() => notifications.hide(notificationId)}
      />
    ),
  });
};

export const showSuccessToast = ({
  title,
  message,
  autoClose = 3000,
}: {
  title?: string;
  message?: string;
  autoClose?: number;
}) => {
  notifications.show({
    withCloseButton: true,
    autoClose,
    title,
    message,
    icon: <IconCheck />,
    color: "green",
  });
};

export const showErrorToast = ({
  id,
  title,
  message,
  autoClose = 3000,
  color = "red",
}: {
  id?: string;
  title?: string;
  message?: string;
  autoClose?: number | false;
  color?: string;
}) => {
  notifications.show({
    id,
    withCloseButton: true,
    autoClose,
    title,
    message,
    icon: <IconX />,
    color,
  });
};
